import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Item from '../../../components/itens/item'


function ContasScreen() {
    return (
        <Fragment>
            <Head titulo="Audiências Públicas de Prestação de Contas" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/contas'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <Row xs={1} lg={2}>
                    <Col>
                        <Item
                            titulo={"Metas Fiscais"}
                            descricao={"Atas das Audiências Públicas de apresentação das Metas Fiscais do Município."}
                            link={"audiencias/metasfiscais"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Saúde"}
                            descricao={"Atas das Audiências Públicas de apresentação dos Relatórios das Ações, serviços e Aplicações Financeiras em saúde"}
                            link={"../saude/atasaudiencia"}
                            key={2}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Convites das Audiências Públicas"}
                            descricao={"Convites das Audiências Públicas de apresentação de Metas Fiscais e Orçamento da Saúde"}
                            link={"audiencias/convites"}
                            key={2}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ContasScreen;